var $9c5435bc17499bd9$exports = {};
$9c5435bc17499bd9$exports = {
  "Empty": `\xdcres`
};
export { $9c5435bc17499bd9$exports as default };